import { saveEmployeeFilter } from "../../infrastructure/employees-filter";
import { displaySubsidyEmployees } from "./displays/allowance/display-subsidy-employees";

export async function searchEmployeeSubsidyTable({
  value,
  model,
  mealBenefit,
  transportBenefit,
  nurseryBenefit,
  recurrentSubsidy,
  employeeIds,
  employeesItems,
}) {
  saveEmployeeFilter({ forState: "subsidy", searchString: value });

  displaySubsidyEmployees({
    model,
    mealBenefit,
    transportBenefit,
    nurseryBenefit,
    recurrentSubsidy,
    employeeIds,
    employeesItems,
  });
}
